/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicValidateCredentials extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicValidateCredentials");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicValidateCredentials.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicValidateCredentials>): BackgroundJobPayloadForPeriodicValidateCredentials {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicValidateCredentials(), model);
        BackgroundJobPayloadForPeriodicValidateCredentials.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicValidateCredentials>): BackgroundJobPayloadForPeriodicValidateCredentials {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicValidateCredentials.newInstance(<BackgroundJobPayloadForPeriodicValidateCredentials> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicValidateCredentials) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicValidateCredentials.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicValidateCredentials): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicValidateCredentials.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
